export const TRIGGERS_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX =
  'triggers-tab-user:';
